var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { attrs: { header: "投保人员" } },
        [
          _vm.getFormConfig.label
            ? _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.clearPLabel(_vm.getFormConfig.label)),
                  },
                }),
              ])
            : _vm._e(),
          [
            _vm.isShowAlert
              ? _c("el-alert", {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: {
                    title: _vm.isShowAlert,
                    "show-icon": "",
                    type: "warning",
                  },
                })
              : _vm._e(),
            _c(
              "el-row",
              [
                _c("avue-crud", {
                  ref: "refEmp",
                  class: _vm.isEmployeeSubmit ? "emp_submitted" : "",
                  attrs: {
                    data: _vm.getOnPageItemData,
                    option: _vm.optionEmployee,
                    page: _vm.empPage,
                    "table-loading": _vm.employeeLoading,
                  },
                  on: {
                    "update:page": function ($event) {
                      _vm.empPage = $event
                    },
                    "current-row-change": _vm.onCurrentRowChange,
                    "cell-click": _vm.onCellClick,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "professionIdHeader",
                      fn: function (ref) {
                        var column = ref.column
                        return [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(column.label) +
                              "\n\t\t\t\t\t\t"
                          ),
                          !_vm.isEmployeeSubmit
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onClearProfession()
                                    },
                                  },
                                },
                                [_vm._v("\n\t\t\t\t\t\t\t清空\n\t\t\t\t\t\t")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "menuRight",
                      fn: function (ref) {
                        return [
                          _c(
                            "div",
                            { staticClass: "u-flex" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    loading: _vm.isDownLoading,
                                    icon: "el-icon-circle-close",
                                  },
                                  on: { click: _vm.onClearAllData },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t一键清空\n\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    loading: _vm.isDownLoading,
                                    icon: "el-icon-download",
                                  },
                                  on: { click: _vm.handleGetEmployeeTemplate },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t模版\n\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    "auto-upload": false,
                                    "on-change": _vm.handleEmployeeFileChange,
                                    "show-file-list": false,
                                    accept:
                                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
                                    action: "",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "el-icon-upload2",
                                      attrs: { type: "primary" },
                                    },
                                    [_vm._v("批量上传")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "menuLeft",
                      fn: function (ref) {
                        return [
                          _c(
                            "div",
                            { staticClass: "u-flex" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    loading: _vm.isDownLoading,
                                    icon: "el-icon-plus",
                                    type: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onAddEmp(false)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t新增\n\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    loading: _vm.isDownLoading,
                                    icon: "el-icon-plus",
                                    type: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$refs.refCardDialog.show()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t身份证批量上传\n\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "menu",
                      fn: function (ref) {
                        var index = ref.index
                        return [
                          _c(
                            "div",
                            { staticClass: "u-flex u-row-center" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    loading: _vm.isDownLoading,
                                    icon: "el-icon-circle-close",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDelEmp(index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t删除\n\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("el-row", { attrs: { justify: "end", type: "flex" } }, [
              _c(
                "div",
                { staticClass: "u-m-t-10 u-font-16 u-font-weight-bold" },
                [
                  _vm._v("\n\t\t\t\t\t保费合计：\n\t\t\t\t\t"),
                  _c("span", { staticClass: "red-bold" }, [
                    _vm._v(_vm._s(_vm.totalPrice)),
                  ]),
                  _vm._v("\n\t\t\t\t\t元\n\t\t\t\t"),
                ]
              ),
            ]),
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                !_vm.isEmployeeSubmit
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          loading: _vm.employeeLoading,
                          icon: "el-icon-check",
                          type: "primary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSubmitEmployee()
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\t\t确认\n\t\t\t\t")]
                    )
                  : _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-edit" },
                        on: {
                          click: function ($event) {
                            return _vm.onCheckEmpResult(false)
                          },
                        },
                      },
                      [_vm._v("修改")]
                    ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c("card-dialog", {
        ref: "refCardDialog",
        on: { onCardSuccess: _vm.onCardSuccess },
      }),
      _c("InsureNotices", {
        ref: "refInsureNoticesHint",
        on: {
          onToSureEnd: _vm.onConfirmAutoStatus,
          onToCancel: _vm.onToCancel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }